export default {
      id: "tt-table-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#tt-table",
      toString: function () {
        return this.url;
      }
    }